import { create } from "zustand";

/** One short line over the screen — "+150 of each: step done" (29 Sep 2026). */
interface ToastState {
  text: string | null;
  seq: number;
  show: (text: string) => void;
  clear: () => void;
}

export const useToastStore = create<ToastState>((set, get) => ({
  text: null,
  seq: 0,
  show: (text) => set({ text, seq: get().seq + 1 }),
  clear: () => set({ text: null }),
}));
